import React, { useEffect, useState } from "react";
import { Button, Card, Col, ListGroup, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetFoodItemDetailsQuery } from "../slices/FoodItemSilce";
import { useSelector } from "react-redux";

const FoodItemDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { foodItemId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    data: foodItem,
    isLoading,
    error,
    refetch,
  } = useGetFoodItemDetailsQuery({
    id: foodItemId,
    token: userInfo.token,
  });

  useEffect(() => {
    if (!isLoading && !error) {
      refetch();
    }
  }, [isLoading, error, refetch]);

  const handleEditStatus = () => {
    navigate(`/editFoodItem/${foodItem._id}`, { state: { foodItem } });
  };

  const fromPage = location.state?.from;
  const showEditButton = location.state?.showEdit !== false;

  const handleBack = () => {
    if (fromPage === "allFoodItems") {
      navigate("/allFoods");
    } else {
      navigate("/viewMyOutlets");
    }
  };

  return (
    <>
      <Row className="mb-3">
        <Col>
          <Button variant="primary" onClick={handleBack}>
            Back
          </Button>
        </Col>
      </Row>

      <h5>Food Details</h5>

      <Row>
        <Col md={5}>
          <Card>
            <ListGroup>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Item Name:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.itemName}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Local Name:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.localName}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Category:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.itemCategory}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Available Quantity:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.itemQuantity}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Currently Selling:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.currentlySelling ? "Yes" : "No"}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Original Price:</strong>
                  </Col>
                  <Col>
                    <strong>₹{foodItem?.itemOriginalPrice}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Offer Price:</strong>
                  </Col>
                  <Col>
                    <strong>₹{foodItem?.itemOfferPrice}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>

              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Discount Percentage</strong>:
                  </Col>
                  <Col>
                    <strong>{foodItem?.discountPercent ?? 0}%</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Discount Amount:</strong>
                  </Col>
                  <Col>
                    <strong>₹{foodItem?.discountAmount ?? 0}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>GST Tax:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.gstTax ?? 0}%</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Added By:</strong>
                  </Col>
                  <Col>
                    <strong>{foodItem?.addedBy}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
      {showEditButton && (
        <Row style={{ marginTop: "1rem", marginBottom: "1rem" }}>
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <Button variant="primary" onClick={handleEditStatus}>
              Edit
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default FoodItemDetailsScreen;
